import { render, staticRenderFns } from "./SmCardTicketCommentUpdate.vue?vue&type=template&id=0305c582&scoped=true&"
import script from "./SmCardTicketCommentUpdate.vue?vue&type=script&lang=ts&"
export * from "./SmCardTicketCommentUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./SmCardTicketCommentUpdate.vue?vue&type=style&index=0&id=0305c582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0305c582",
  null
  
)

export default component.exports